import React from 'react';
import { classNames, isFunction } from '@philips-internal/oswald-ui-utils';
import { isActive, isSmall, isXSM } from './bullet-trail-utils.js';
import './bullet-trail.css';
const DEFAULT_LIMIT = 5;
const onClickHandler = (onClick) => {
    if (!isFunction(onClick)) {
        return;
    }
    onClick();
};
function BulletTrail(props) {
    const { className: customClassName, limit = DEFAULT_LIMIT, length, onClick, page } = props;
    const amount = length >= limit ? limit : length;
    const trailClassName = classNames({
        'c-bullet-trail': true,
        [`${customClassName}`]: Boolean(customClassName),
    });
    return (React.createElement("ul", { className: trailClassName, onClick: () => onClickHandler(onClick) }, new Array(amount).fill(undefined).map((_, index) => {
        const options = {
            index,
            length,
            limit,
            page,
        };
        const trailItemClassName = classNames({
            'c-bullet-trail__item': true,
            'c-bullet-trail__item--active': isActive(options),
            'c-bullet-trail__item--previous': page > index,
            'c-bullet-trail__item--small': isSmall(options),
            'c-bullet-trail__item--xsmall': isXSM(options),
        });
        return React.createElement("li", { className: trailItemClassName, key: index });
    })));
}
export { BulletTrail, };
//# sourceMappingURL=bullet-trail.js.map